import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles(theme => ({
  actionButton: {
    padding: '10px 32px',
    background: theme.palette.common.white,
    color: theme.palette.primary.main,
  },
}));
